export enum UploadCompaniesBreadCrumbs {
    UPLOAD_LIST = 'Upload list',
    MATCH_COMPANIES = 'Match companies',
    SUBMIT = 'Submit',
}
